import { motion } from "framer-motion";
import { Star, Users, MonitorPlay, Briefcase } from "lucide-react";

const OUTCOMES = [
  { icon: Star, title: "Real client portfolio", text: "Finished live-project work — not practice exercises." },
  { icon: Users, title: "Agency exposure", text: "See how a working production company operates." },
  { icon: MonitorPlay, title: "Portfolio website", text: "Your work presented professionally for employers." },
  { icon: Briefcase, title: "Career kit", text: "Placement assistance and tools to start working." },
];

export default function OutcomesSection() {
  return (
    <section className="bg-lima-cream text-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-black/10" data-testid="outcomes-section">
      <p className="text-center font-mono2 text-[10px] md:text-xs tracking-[0.25em] text-black/50 underline underline-offset-8 decoration-black/30 mb-8">
        BUILT FOR THE CREATIVE INDUSTRY
      </p>
      <motion.h2
        initial={{ opacity: 0, y: 40, scale: 1.03, filter: "blur(16px)" }}
        whileInView={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-center max-w-4xl mx-auto mb-12 md:mb-24"
      >
        Leave ready to{" "}
        <span className="font-serifit font-normal text-[#3a3a36]">create, collaborate and get hired.</span>
      </motion.h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-y border-black/15">
        {OUTCOMES.map((o, i) => (
          <motion.div
            key={o.title}
            initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className={`text-center px-8 py-12 md:py-16 border-black/15 ${i > 0 ? "border-t sm:border-t lg:border-t-0 lg:border-l" : ""} ${i === 2 ? "sm:border-t lg:border-t-0" : ""} ${i % 2 === 1 ? "sm:border-l" : ""}`}
            data-testid={`outcome-${i}`}
          >
            <o.icon size={26} strokeWidth={1.5} className="text-lima-blue mx-auto mb-8" />
            <p className="font-display font-bold text-lg md:text-xl tracking-tight">{o.title}</p>
            <p className="mt-2 text-sm text-black/55 leading-relaxed">{o.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
